import { For, Show } from 'solid-js';
import { MODES } from '@domain/modes/modes';
import { modeStore } from '@state/modeStore';
import { ActivityChart } from '@ui/Quiz/ActivityChart';
import './ModeHeats.css';

export function ModeHeats() {
  const ordered = () => {
    const current = MODES.find((m) => m.id === modeStore.current) ?? MODES[0]!;
    return [current, ...MODES.filter((m) => m.id !== current.id)];
  };

  return (
    <div class="mode-heats">
      <For each={ordered()}>
        {(mode, i) => (
          <section
            class="mode-heat"
            classList={{ 'mode-heat--current': i() === 0 }}
            aria-label={`${mode.label} heatmap`}
          >
            <Show when={i() > 0}>
              <h2 class="mode-heat__title">{mode.label}</h2>
            </Show>
            <ActivityChart activity={modeStore.activities[mode.id]} />
          </section>
        )}
      </For>
    </div>
  );
}
